import { useDroppable } from '@dnd-kit/core'
import { cn } from '@/lib/utils'

type Props = {
  className?: string
  orientation: 'before' | 'after'
  id: string | number
}

const EntityDroppable = ({ className, orientation, id }: Props) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `${orientation}-${id}`,
  })

  return (
    <span
      className={cn(
        'absolute w-full',
        orientation === 'before'
          ? 'h-8 -top-0.5 border-t border-dashed'
          : 'h-7 top-7 border-b border-dashed',
        isOver ? 'border-foreground' : 'border-transparent',
        className,
      )}
      ref={setNodeRef}
    />
  )
}

export default EntityDroppable
